import { render, staticRenderFns } from "./AttachmentsTab.vue?vue&type=template&id=6efed494&scoped=true"
import script from "./AttachmentsTab.vue?vue&type=script&lang=js"
export * from "./AttachmentsTab.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsTab.vue?vue&type=style&index=0&id=6efed494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efed494",
  null
  
)

export default component.exports